(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cmx-product-card"] && !Shopify.designMode) return;
  try {
    // SafeSearch/peso (QA 2026-10): crea la 2ª foto de la tarjeta solo al primer hover real.
  // Googlebot no pasa el ratón, así que esas fotos no forman parte de la página indexada.
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', function (event) {
      var card = event.target.closest ? event.target.closest('.cmx-coll-main__product-card') : null;
      if (!card) return;
      var slot = card.querySelector('[data-cmx-hover-src]');
      if (!slot) return;
      var img = document.createElement('img');
      img.src = slot.getAttribute('data-cmx-hover-src');
      img.alt = '';
      img.width = 600;
      img.height = 600;
      img.decoding = 'async';
      img.className = 'cmx-coll-main__product-img cmx-coll-main__product-img--hover';
      slot.replaceWith(img);
    }, { passive: true });
  }

  // «Agotado · Avísame»: abre la ventana de CartBite (app embed «Back in stock») con la variante de la
  // tarjeta, igual que su botón de la ficha. CartBite carga su script ~1,5 s después de la página y su
  // ventana es un iframe que se monta al pedirla; si no llega a estar lista, lleva a la ficha en esa variante.
  (function () {
    function wait(check, ms) {
      return new Promise(function (resolve) {
        var start = Date.now();
        (function poll() {
          var value = check();
          if (value || Date.now() - start > ms) return resolve(value);
          setTimeout(poll, 100);
        })();
      });
    }
    function cartbite() {
      var config = window.initVar;
      if (!window.growClient || !config || !config.stockWidget || !config.stockWidget.isEnabled) return null;
      if (typeof config.addPopUp !== 'function' || typeof config.stockWidgetClicked !== 'function') return null;
      return config;
    }
    function mountPopup() {
      var config = cartbite();
      if (config) config.addPopUp(config.stockWidget.popupSelector, config.stockWidget.modalHtml);
      return config;
    }
    function popupReady() {
      var config = cartbite();
      return config && window.growCampaignPopUps && window.growCampaignPopUps[config.stockWidget.popupSelector] ? config : null;
    }
    function open(button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      var toProduct = function () {
        button.removeAttribute('aria-busy');
        var url = button.getAttribute('data-cmx-notify-url');
        if (url) window.location.href = url;
      };
      wait(cartbite, 5000)
        .then(function (config) {
          if (!config) return null;
          mountPopup();
          return wait(popupReady, 5000);
        })
        .then(function (config) {
          if (!config) return toProduct();
          button.removeAttribute('aria-busy');
          // CartBite solo mira event.target: producto, handle y variante salen de los data-* del botón.
          return Promise.resolve(config.stockWidgetClicked({ target: button })).catch(function () {
            var popup = document.getElementById(config.stockWidget.popupSelector);
            if (!popup || popup.style.display !== 'block') toProduct();
          });
        })
        .catch(toProduct);
    }
    // Monta la ventana al acercarse al botón, para que el clic la abra sin esperar.
    ['pointerover', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target.closest && event.target.closest('[data-cmx-notify]')) mountPopup();
      }, { passive: true });
    });
    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-cmx-notify]') : null;
      if (!button) return;
      event.preventDefault();
      open(button);
    });
  })();

  // «Elegir talla»: pone encima del botón las casillas de cada talla, que añaden su variante (submit con
  // name="id"). Se cierran con Escape o tocando fuera de la tarjeta; la casilla que se toca añade y va
  // a la cesta como el botón de siempre. El botón sigue ocupando su sitio (invisible) para que la
  // tarjeta no cambie de alto; si las casillas no caben en una línea, el panel crece hacia arriba
  // con fondo y sombra (cmx-pick--rows).
  (function () {
    function pickerOf(form) {
      return {
        toggle: form.querySelector('[data-cmx-pick-toggle]'),
        panel: form.querySelector('[data-cmx-pick]')
      };
    }
    function setOpen(form, open, focus) {
      var picker = pickerOf(form);
      if (!picker.toggle || !picker.panel) return;
      picker.panel.hidden = !open;
      picker.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        picker.panel.classList.remove('cmx-pick--rows');
        if (picker.panel.offsetHeight > picker.toggle.offsetHeight + 8) picker.panel.classList.add('cmx-pick--rows');
      }
      if (!focus) return;
      if (open) {
        var first = picker.panel.querySelector('.cmx-pick__opt:not([disabled])');
        if (first) first.focus();
      } else {
        picker.toggle.focus();
      }
    }
    function closeAll(except) {
      document.querySelectorAll('[data-cmx-pick]:not([hidden])').forEach(function (panel) {
        var form = panel.closest('form');
        if (form && form !== except) setOpen(form, false, false);
      });
    }
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest ? event.target.closest('[data-cmx-pick-toggle]') : null;
      if (toggle) {
        var form = toggle.closest('form');
        closeAll(form);
        setOpen(form, true, true);
        return;
      }
      var inside = event.target.closest ? event.target.closest('.cmx-coll-main__form') : null;
      closeAll(inside);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var panel = event.target.closest ? event.target.closest('[data-cmx-pick]') : null;
      if (panel) setOpen(panel.closest('form'), false, true);
    });
    document.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.classList.contains('cmx-pick__opt')) submitter.setAttribute('aria-busy', 'true');
    });
    // Volver atrás desde la cesta (bfcache): la tarjeta vuelve con el botón, no con las tallas abiertas.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      closeAll(null);
      document.querySelectorAll('.cmx-pick__opt[aria-busy]').forEach(function (button) { button.removeAttribute('aria-busy'); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-spec-badges"] && !Shopify.designMode) return;
  try {
    (function(){
  /* Círculo de colores de la tarjeta: cada toque enseña la foto del color siguiente y deja el enlace y
     «Añadir a la cesta» en ese color. Al pasar el ratón por la foto (y en la miniatura de lencería), en
     vez de la 2.ª foto se ve la del color siguiente; sobre el círculo, el elegido (ver el CSS).
     Va antes que los tooltips: en móvil, su toque enseña ya el color nuevo. */
  if (window.__cmxColorCycleInit) return;
  window.__cmxColorCycleInit = true;
  function colorsOf(dot){
    if (!dot.__cmxColors) {
      try { dot.__cmxColors = JSON.parse(dot.getAttribute('data-cmx-colors') || '[]'); } catch (err) { dot.__cmxColors = []; }
    }
    return dot.__cmxColors;
  }
  function current(dot){
    return parseInt(dot.getAttribute('data-cmx-color-index') || '0', 10);
  }
  // Foto de hover (en lencería, la miniatura de la esquina): la cambia si ya existe y, si no, deja
  // la nueva en el hueco del que la crea el script de la tarjeta.
  function setHover(card, src){
    if (!src) return;
    var slot = card.querySelector('[data-cmx-hover-src]');
    if (slot) slot.setAttribute('data-cmx-hover-src', src);
    var hover = card.querySelector('.cmx-coll-main__product-img--hover');
    if (hover && hover.getAttribute('src') !== src) {
      hover.src = src;
      hover.removeAttribute('srcset');
    }
  }
  // En vez de la 2.ª foto, la del color siguiente.
  function preview(card, dot){
    var colors = colorsOf(dot);
    if (colors.length < 2) return;
    setHover(card, colors[(current(dot) + 1) % colors.length].i);
  }
  function next(dot){
    show(dot, current(dot) + 1, true);
  }
  // Deja la tarjeta en el color «index»: foto, enlace, «Añadir a la cesta» y tooltip.
  function show(dot, index, fromUser){
    var colors = colorsOf(dot);
    var card = dot.closest('.cmx-coll-main__product-card');
    if (!card || colors.length < 2) return;
    index = index % colors.length;
    var color = colors[index];
    dot.setAttribute('data-cmx-color-index', String(index));
    var img = card.querySelector('.cmx-coll-main__product-img:not(.cmx-coll-main__product-img--hover)');
    if (img && color.i) {
      img.src = color.i;
      img.removeAttribute('srcset');
    }
    // El vídeo de tarjeta es del color de antes. La foto de hover (oculta mientras el ratón está en
    // el círculo) y la miniatura de lencería pasan ya al color siguiente.
    card.querySelectorAll('.cmx-coll-main__product-video').forEach(function(el){ el.remove(); });
    preview(card, dot);
    if (color.u) {
      card.querySelectorAll('a.cmx-coll-main__product-link, .cmx-coll-main__product-title a').forEach(function(a){ a.href = color.u; });
    }
    var input = card.querySelector('.cmx-coll-main__form input[name="id"]');
    if (input && color.v) input.value = color.v;
    // Color sin stock: en vez de «Añadir a la cesta» apagado, «Agotado · Avísame» con ese color (ver cmx-product-card).
    var button = card.querySelector('.cmx-coll-main__add-btn');
    var notify = card.querySelector('[data-cmx-notify]');
    if (button) {
      button.disabled = !color.a;
      button.hidden = !color.a && !!notify;
    }
    if (notify) {
      notify.hidden = color.a;
      if (color.v) notify.setAttribute('data-variant-id', String(color.v));
      if (color.u) notify.setAttribute('data-cmx-notify-url', color.u);
    }
    var label = color.n + ' (' + (index + 1) + ' de ' + colors.length + ')' + (color.a ? '' : ' · agotado');
    dot.setAttribute('data-tooltip', label);
    dot.setAttribute('aria-label', label);
    dot.setAttribute('title', label);
    if (fromUser && !window.matchMedia('(pointer: coarse)').matches) {
      dot.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    }
  }
  // Al entrar en la tarjeta (no al moverse dentro). En captura: llega antes que el script de la
  // tarjeta, que crea la foto de hover en este mismo evento.
  document.addEventListener('pointerover', function(e){
    var card = e.target.closest ? e.target.closest('.cmx-coll-main__product-card') : null;
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    var dot = card.querySelector('.spec-ricon--colors[data-cmx-colors]');
    if (dot) preview(card, dot);
  }, { capture: true, passive: true });
  // La miniatura de lencería está ya en el HTML con la 2.ª foto.
  function previewLingerie(){
    document.querySelectorAll('.cmx-coll-main__product-card--lingerie .spec-ricon--colors[data-cmx-colors]').forEach(function(dot){
      preview(dot.closest('.cmx-coll-main__product-card'), dot);
    });
  }
  // Con el filtro de color de la colección activo (?filter.p.m.custom.color=Transparente), la
  // tarjeta sale ya en ese color si la ficha lo tiene y no es el que enseña.
  function norm(text){
    return String(text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  function showFiltered(){
    var wanted = [];
    try {
      new URLSearchParams(window.location.search).forEach(function(value, key){
        if (key === 'filter.p.m.custom.color' || /^filter\.v\.option\.colou?r$/i.test(key)) wanted.push(norm(value));
      });
    } catch (err) { return; }
    if (!wanted.length) return;
    document.querySelectorAll('.spec-ricon--colors[data-cmx-colors]').forEach(function(dot){
      var colors = colorsOf(dot);
      if (colors.length < 2 || wanted.indexOf(norm((colors[current(dot)] || {}).n)) !== -1) return;
      for (var i = 0; i < colors.length; i++) {
        if (wanted.indexOf(norm(colors[i].n)) !== -1) { show(dot, i, false); return; }
      }
    });
  }
  function onLoad(){
    showFiltered();
    previewLingerie();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();
  document.addEventListener('click', function(e){
    var dot = e.target.closest ? e.target.closest('.spec-ricon--colors[data-cmx-colors]') : null;
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    next(dot);
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = e.target.closest ? e.target.closest('.spec-ricon--colors[data-cmx-colors]') : null;
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    next(dot);
  }, true);
})();
(function(){
  if (window.__gxTooltipInit) return;
  window.__gxTooltipInit = true;
  var tt = document.createElement('div');
  tt.id = 'gx-product-spec-tooltip';
  tt.className = 'gx-tooltip';
  tt.setAttribute('role', 'tooltip');
  tt.setAttribute('aria-hidden', 'true');
  document.body.appendChild(tt);
  var activeTarget = null;
  var touchHideTimer = null;
  function show(target){
    var txt = target.getAttribute('data-tooltip');
    if (!txt) return;
    if (activeTarget && activeTarget !== target) {
      activeTarget.removeAttribute('aria-describedby');
    }
    activeTarget = target;
    target.setAttribute('aria-describedby', tt.id);
    tt.textContent = txt;
    var r = target.getBoundingClientRect();
    tt.style.left = (r.left + r.width / 2) + 'px';
    tt.style.top = r.top + 'px';
    tt.setAttribute('aria-hidden', 'false');
    tt.classList.add('is-visible');
  }
  function hide(){
    tt.classList.remove('is-visible');
    tt.setAttribute('aria-hidden', 'true');
    if (activeTarget) {
      activeTarget.removeAttribute('aria-describedby');
      activeTarget = null;
    }
  }
  document.addEventListener('mouseover', function(e){
    var t = e.target.closest('[data-tooltip]');
    if (t) show(t);
  });
  document.addEventListener('mouseout', function(e){
    var t = e.target.closest('[data-tooltip]');
    if (t && (!e.relatedTarget || !t.contains(e.relatedTarget))) hide();
  });
  document.addEventListener('click', function(e){
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    var t = e.target.closest('[data-tooltip]');
    if (!t) {
      hide();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    show(t);
    if (touchHideTimer) window.clearTimeout(touchHideTimer);
    touchHideTimer = window.setTimeout(hide, 2200);
  }, true);
  window.addEventListener('scroll', hide, true);
})();
(function(){
  if (window.__effectCycleInit) return;
  window.__effectCycleInit = true;
  function tick(){
    var nodes = document.querySelectorAll('.spec-effect--cycle');
    for (var k = 0; k < nodes.length; k++){
      var el = nodes[k];
      var frames = el.querySelectorAll('.cycle-frame');
      if (frames.length <= 1) continue;
      var i = parseInt(el.getAttribute('data-idx') || '0', 10);
      frames[i].classList.remove('is-active');
      i = (i + 1) % frames.length;
      frames[i].classList.add('is-active');
      el.setAttribute('data-idx', i);
      el.setAttribute('data-current-slug', frames[i].getAttribute('data-slug'));
      var lbl = frames[i].getAttribute('data-label');
      if (lbl) {
        el.setAttribute('data-tooltip', lbl);
        el.setAttribute('aria-label', lbl);
        el.setAttribute('title', lbl);
      }
    }
  }
  setInterval(tick, 3000);
})();
  } catch(e) { console.error(e); }
})();

})();
